import { useState, useLayoutEffect, useRef } from 'react'
import { useConversations } from '../hooks/useConversations'
import Message from './Message'
import Composer from './Composer'
import DeleteConfirmModal from './DeleteConfirmModal'

function ChatPage() {
  const {
    currentConvoData,
    deleteModal,
    sendMessage,
    confirmDeleteConvo,
    cancelDeleteConvo
  } = useConversations()

  const [text, setText] = useState('')
  const [busy, setBusy] = useState(false)
  const threadRef = useRef()

  const handleSendMessage = async () => {
    if (!text.trim() || busy) return

    const messageText = text.trim()
    setBusy(true)

    try {
      await sendMessage(messageText)
      setText('') // Only clear input after successful send
    } catch (error) {
      // Keep the original text in input so user can retry
      console.error('Failed to send message:', error)
    } finally {
      setBusy(false)
    }
  }

  const scrollToBottom = () => {
    if (threadRef.current) {
      threadRef.current.scrollTo({
        top: threadRef.current.scrollHeight,
        behavior: 'smooth'
      })
    }
  }

  // Auto-scroll whenever messages change (after DOM updates)
  useLayoutEffect(() => {
    scrollToBottom()
  }, [currentConvoData?.messages])

  return (
    <>
      <div className="thread" ref={threadRef}>
        {currentConvoData?.messages.length > 0 ? (
          currentConvoData.messages.map((message) => (
            <Message key={message.id} message={message} />
          ))
        ) : (
          <div className="no-messages">
            Ready when you are. Let's see what your inbox has for me.
          </div>
        )}
      </div>

      <Composer text={text} setText={setText} onSend={handleSendMessage} busy={busy} />

      <DeleteConfirmModal
        isOpen={deleteModal.isOpen}
        onClose={cancelDeleteConvo}
        onConfirm={confirmDeleteConvo}
        conversationTitle={deleteModal.convoTitle}
      />
    </>
  )
}

export default ChatPage